﻿<div class="route-component">
    <div class="form-component">
        <h4>Create or Update POPI Mapping</h4>

        <form>
            <div class="form-columns">
                <div class="left-column">
                    <div class="input-group">
                        <label for="displayName">
                            Display Name:<span class="required"> *</span>
                        </label>
                        <div>
                            <input name="displayName" [(ngModel)]="formValues.displayName" #displayNameInput="ngModel"
                                placeholder="Display Name" [class.invalid]="displayNameInput.invalid && displayNameInput.touched" required>

                            <div *ngIf="displayNameInput.invalid && displayNameInput.touched">
                                    <span class="error">Display Name is required</span>
                            </div>
                        </div>
                    </div>

                    <div class="input-group">
                        <label for="tableName">
                            Table:<span class="required"> *</span>
                        </label>
                        <div>
                            <select name="tableName" [(ngModel)]="formValues.tableName" #tableNameSelect="ngModel" (change)="onTableChange()" [class.invalid]="tableNameSelect.invalid && tableNameSelect.touched" required>
                                    <option value="">Select Table</option>
                                    <option *ngFor="let table of tables" [value]="table.tableName">{{ table.tableName }}</option>
                            </select>

                            <div *ngIf="tableNameSelect.invalid && tableNameSelect.touched">
                                <span class="error">Table is required</span>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="formValues.parentTableName" class="input-group">
                        <label for="parentIdColumn">
                            Parent ID Column:<span class="required"> *</span>
                        </label>
                        <div>
                            <select name="parentIdColumn" [(ngModel)]="formValues.parentIdColumn" #parentIdColumnSelect="ngModel" [class.invalid]="parentIdColumnSelect.invalid && parentIdColumnSelect.touched" required>
                                    <option value="">Select Parent Identifier</option>
                                    <option *ngFor="let field of parentFields" [value]="field.fieldName">
                                        {{ field.fieldName }}
                                    </option>
                            </select>

                            <div *ngIf="parentIdColumnSelect.invalid && parentIdColumnSelect.touched">
                                <span class="error">Parent Identifier Column is required</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="right-column">
                    <div class="input-group">
                        <label for="dbName">
                            Database:<span class="required"> *</span>
                        </label>
                        <div>
                            <select name="dbName" [(ngModel)]="formValues.dbName" #dbNameSelect="ngModel" (change)="onDbChange()" [class.invalid]="dbNameSelect.invalid && dbNameSelect.touched" required>
                                <option value="">Select Database</option>
                                <option *ngFor="let db of schemaSummaries.summaries" [value]="db.dbName">
                                    {{ db.dbName }}
                                </option>
                            </select>

                            <div *ngIf="dbNameSelect.invalid && dbNameSelect.touched">
                                <span class="error">Database is required</span>
                            </div>
                        </div>
                    </div>

                    <div class="input-group">
                        <label for="parentTableName">
                          Parent Table:
                        </label>
                        <div>
                            <select name="parentTableName" [(ngModel)]="formValues.parentTableName" #parentTableNameSelect="ngModel" (change)="onParentTableChange()" [class.invalid]="parentTableNameSelect.invalid && parentTableNameSelect.touched">
                                <option value="">Select Parent</option>
                                <option *ngFor="let table of tables" [value]="table.tableName">
                                    {{ table.tableName }}
                                </option>
                            </select>

                            <div *ngIf="parentTableNameSelect.invalid && parentTableNameSelect.touched">
                                <span class="error">Parent Table is required</span>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="formValues.parentTableName" class="input-group">
                        <label for="identifierColumn">
                            Identifier Column:<span class="required"> *</span>
                        </label>
                        <div>
                            <select name="identifierColumn" [(ngModel)]="formValues.identifierColumn" #identifierColumnSelect="ngModel" required [class.invalid]="identifierColumnSelect.invalid && identifierColumnSelect.touched">
                                    <option value="">Select Identifier</option>
                                    <option *ngFor="let field of schemaFields" [value]="field.fieldName">
                                        {{ field.fieldName }}
                                    </option>
                            </select>

                            <div *ngIf="identifierColumnSelect.invalid && identifierColumnSelect.touched">
                                <span class="error">Identifier Column is required</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="fields.length > 0 || formValues.tableName" class="fields-section">
                <h4>Fields Mapping</h4>

                <table class="fields-table">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Display Name</th>
                            <th>Replace Value</th>
                            <th>Search Field</th>
                            <th>De-Identify</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <!-- Existing fields -->
                        <tr *ngFor="let field of fields; let i = index">
                            <td>{{ field.fieldName }}</td>
                            <td>{{ field.displayName }}</td>
                            <td>{{ field.replaceValue }}</td>
                            <td>
                                <label class="switch">
                                <input type="checkbox" [(ngModel)]="field.search" [ngModelOptions]="{standalone: true}" name="search{{i}}">
                                <span class="slider">
                                    <span class="toggle-text" [class.selected]="field.search">{{ field.search ? 'Yes' : 'No' }}</span>
                                </span>
                                </label>
                            </td>
                            <td>
                                <label class="switch">
                                <input type="checkbox" [(ngModel)]="field.piField" [ngModelOptions]="{standalone: true}" name="piField{{i}}">
                                <span class="slider">
                                    <span class="toggle-text" [class.selected]="field.piField">{{ field.piField ? 'Yes' : 'No' }}</span>
                                </span>
                                </label>
                            </td>
                            <td>
                                <button type="button" (click)="removeField(i)" class="button-cancel">Delete</button>
                            </td>
                        </tr>

                        <!-- New Field Adding Row -->
                        <tr>
                            <td>
                                <div *ngIf="formValues.tableName" class="input-group">
                                    <label for="newFieldName">Name:<span class="required"> *</span></label>
                                    <div>
                                        <select name="newFieldName" [(ngModel)]="newField.fieldName" [ngModelOptions]="{standalone: true}" #newFieldName="ngModel" [class.invalid]="newFieldName.invalid && newFieldName.touched" required>
                                            <option value="">Select Field</option>
                                            <option *ngFor="let field of schemaFields" [value]="field.fieldName">
                                                {{ field.fieldName }}
                                            </option>
                                        </select>
                                        <div *ngIf="newFieldName.invalid && newFieldName.touched">
                                            <span class="error">Field Name is required</span>
                                        </div>
                                    </div>
                                </div>
                            </td>

                            <td>
                                <div class="input-group">
                                    <label for="newFieldDisplayName">Display Name:<span class="required"> *</span></label>
                                    <div>
                                        <input name="newFieldDisplayName" type="text" [(ngModel)]="newField.displayName" [ngModelOptions]="{standalone: true}" #newFieldDisplayName="ngModel" placeholder="Display Name" [class.invalid]="newFieldDisplayName.invalid && newFieldDisplayName.touched" required>
                                        <div *ngIf="newFieldDisplayName.invalid && newFieldDisplayName.touched">
                                        <span class="error">Display Name is required</span>
                                        </div>
                                    </div>
                                </div>
                            </td>

                            <td>
                                <div class="input-group">
                                    <label for="newFieldReplaceValue">Replace Value:<span class="required"> *</span></label>
                                    <div>
                                        <input name="newFieldReplaceValue" type="text" [(ngModel)]="newField.replaceValue" [ngModelOptions]="{standalone: true}" #newFieldReplaceValue="ngModel" placeholder="[REDACTED]" [required]="newField.piField" [class.invalid]="newField.piField && newFieldReplaceValue.invalid && newFieldReplaceValue.touched">
                                        <div *ngIf="newField.piField && newFieldReplaceValue.invalid && newFieldReplaceValue.touched">
                                            <span class="error">Replace Value is required if De-Identify is on</span>
                                        </div>
                                    </div>
                                </div>
                            </td>

                            <td>
                                <label class="switch">
                                    <input type="checkbox" [(ngModel)]="newField.search" [ngModelOptions]="{standalone: true}" name="newFieldSearch">
                                    <span class="slider">
                                        <span class="toggle-text" [class.selected]="newField.search">{{ newField.search ? 'Yes' : 'No' }}</span>
                                    </span>
                                </label>
                            </td>

                            <td>
                                <label class="switch">
                                    <input type="checkbox" [(ngModel)]="newField.piField" [ngModelOptions]="{standalone: true}" name="newFieldPiField">
                                    <span class="slider">
                                        <span class="toggle-text" [class.selected]="newField.piField">{{ newField.piField ? 'Yes' : 'No' }}</span>
                                    </span>
                                </label>
                            </td>

                            <td>
                                <button type="button" (click)="saveNewField()" class="button">Save</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="action-bar">
                <button type="button" class="button" [disabled]="isSaving" (click)="saveMapping()">
                    <span *ngIf="isSaving" class="loading-spinner"></span>
                    <i *ngIf="!isSaving" class="fas fa-save"></i> Save
                </button>

                <button type="button" class="button-cancel" (click)="cancel()">
                    <i class="fas fa-cancel"></i> Cancel
                </button>
            </div>

        </form>
    </div>
</div>
